import { getViemClients, } from "@bracket/contractor-next";

import {
	getContractWithABI,
	type ValidChainId,
	type TokenIdentifier,
} from "@bracket/chainography";

import type { Config } from "@wagmi/core";
import type { BlockHash } from "@bracket/types";

export declare type EthToBrktETHProps = {
	brkt: bigint;
	eth: bigint;
	config?: Config;
	chainId?: ValidChainId;
};

export declare type EthToBrktETHResult = {
	hash: BlockHash;
	brkt: bigint;
};



/**
 * Converts ETH to BRKTETH using the BrktETHRouter contract
 * @param {EthToBrktETHProps} props - The conversion parameters
 * @param {bigint} props.brkt - The expected amount of BRKTETH to receive
 * @param {bigint} props.eth - The amount of ETH to convert
 * @param {Config} [props.config] - Optional wagmi config
 * @param {ValidChainId} [props.chainId=1] - The chain ID to use (defaults to mainnet)
 * @returns {Promise<EthToBrktETHResult>} The transaction hash and actual BRKTETH amount received
 * @throws {Error} If the transaction fails
 */
export const ethToBrktETH = async ({
	brkt,
	eth,
	config,
	chainId = 1,
}: EthToBrktETHProps): Promise<EthToBrktETHResult> => {
	const [client, wclient] = await getViemClients({ chainId, config });
	const [address, abi] = getContractWithABI("BrktETHRouter", chainId);

	try {

		const {
			request,
			result,
		} = await client.simulateContract({
			address,
			abi,
			functionName: "ethToBrktETH",
			args: [brkt],
			account: wclient.account,
			value: BigInt(Number(eth) * 1.0005),
		});

		const hash = await wclient.writeContract(request);
		await client.waitForTransactionReceipt({ hash });

		return {
			hash,
			brkt: result,
		};

  } catch (err) {

		throw new Error(`@bracket/chainography/brktETHRouter:ethToBrktETH has failed - ${err.message}`);
	}
};
